<template>
  <div>
    <header class="header-global">
      <div class="navbar-main-new">
        <div class="container">
          <div style="display: -webkit-inline-box;">
            <a
                href="#"
                class="language_s"
                :class="localeStyle('uz-UZ')"
                @click.stop.prevent="changeLang('uz-UZ')"
            >o`zb</a
            >
            <a
                href="#"
                class="language_s"
                :class="localeStyle('uz-CYR')"
                @click.stop.prevent="changeLang('uz-CYR')"
            >ўзб</a
            >
            <a
                href="#"
                class="language_s"
                :class="localeStyle('uz-QR')"
                @click.stop.prevent="changeLang('uz-QR')"
            >Qrq</a
            >
            <a
                href="#"
                class="language_s"
                :class="localeStyle('ru-RU')"
                @click.stop.prevent="changeLang('ru-RU')"
            >рус</a
            >
            <a
                href="#"
                class="language_s"
                :class="localeStyle('en-US')"
                @click.stop.prevent="changeLang('en-US')"
            >eng</a
            >

<!--                                <a href="#" class="language_s" :class="localeStyle('en-US')" @click.stop.prevent="changeLang('en-US')">eng</a>-->
          </div>
          <div class="submenu_info mobile">
<!--            <a-->
<!--                href="https://www.facebook.com/UZBBoshprokuraturasi" target="_blank"-->
<!--                class="icon_submenu"-->
<!--            ><img-->
<!--                src="../../public/img/icons/ic_facebook_logo.png"-->
<!--                style="height: 16px;"-->
<!--            /></a>-->
            <a href="https://t.me/uzbprokuratura" class="icon_submenu" target="_blank"
            ><img
                src="../../public/img/icons/ic_telegram.png"
                style="height: 16px;"
            /></a>
            <a href="https://www.instagram.com/boshprokuratura/" class="icon_submenu" target="_blank"
            ><img
                src="../../public/img/icons/ic_instagram.png"
                style="height: 16px;"
            /></a>
            <a href="https://twitter.com/HNShamsutdinov" class="icon_submenu" target="_blank"
            ><img src="../../public/img/icons/ic_twitter.png" style="height: 16px;"
            /></a>
            <!--          <a-->
            <!--            href="https://t.me/HShamsutdinov"-->
            <!--            class="icon_submenu"-->
            <!--            style="margin-right: 25px;"-->
            <!--            ><img-->
            <!--              src="../../public/img/icons/telegram.svg"-->
            <!--              style="height: 16px;"-->
            <!--          /></a>-->
            <!--          <a-->
            <!--            href="https://t.me/HShamsutdinov" target="_blank"-->
            <!--            class="icon_submenu"-->
            <!--            ><img-->
            <!--              src="../../public/img/icons/telegram.svg"-->
            <!--              style="height: 16px;"-->
            <!--          /></a>-->
            <!--                    <a href="#" class="icon_submenu"><img src="../../public/img/icons/smartphone-call.svg" style="height: 16px;"></a>-->
            <!--          <a href="#" class="icon_submenu"-->
            <!--            ><img src="../../public/img/icons/rss.svg" style="height: 16px;"-->
            <!--          /></a>-->
          </div>
          <div class="submenu_info mobile">
            <div class="time_sub_new">
              <span class="new_date">{{ date }}</span>
              <span class="new_time">{{ time }}</span>
              <span class="new_time">(GMT+5)</span>
            </div>
            <!--                    <span class="time_sub_new">21.11.2019 Чт 19:30:20 (GMT+5)</span>-->
          </div>
          <div class="mobile_spec">
            <special-features/>
          </div>
          <div class="mobile_speak">
            <el-button size="mini" @click="speakDialogVisible = true" icon="el-icon-headset" style="width: 22px; height: 22px; padding: 4px; line-height: 15px;" circle></el-button>
          </div>
<!--          <div class="mobile_test">-->
<!--            <span class="test_rejim">{{ $t('dictionary.test_mode') }}</span>-->
<!--          </div>-->
        </div>
      </div>
      <div class="logo_head_new">
        <div class="container">
          <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
            <img style="height: 110px;" :src="$t('app.header_logo')" alt="logo"/>
          </router-link>
          <div class="logo_head_new_text">
            <h5 class="logo_text_h4">{{ $t("app.bosh_pro") }}</h5>
            <h5 class="logo_text_h5">{{ $t("app.bosh_res") }}</h5>
            <span class="logo_text_span">{{ $t("app.bosh_ofis") }}</span>
          </div>
          <div class="logo_head_call mobile_min">
            <router-link to="/prokuraturatizimi">
              <span class="map_text">{{ $t("app.bosh_hudud") }}</span>
              <div class="icon_submenu_map">
                <img
                    src="../../public/img/icons/uz_02.svg"
                    style="height: 90px; margin-top: 14px;"
                />
              </div>
            </router-link>
          </div>

          <div class="logo_head_call mobile_min">
            <h2 class="logo_text_h2">1007</h2>
            <span
                style="color: #fff; text-transform: uppercase; margin-bottom: 5px;"
            >{{ $t("app.bosh_call") }}</span
            >
          </div>
          <div class="logo_head_call mobile_min">
            <a href="#" class="icon_submenu_call"
            ><img
                src="../../public/img/icons/call.svg"
                style="height: 50px; margin-top: 34px;"
            /></a>
          </div>
        </div>
      </div>
      <base-nav
          class="navbar-main mt-27"
          transparent
          type=""
          effect="light"
          expand
      >
        <div>
          <router-link to="/sitemap" class="icon_menunav_new"
          ><img src="../../public/img/icons/sitemap.svg" style="height: 18px;"
          /></router-link>
          <router-link to="/contact" class="icon_menunav_new"
          ><img src="../../public/img/icons/email.svg" style="height: 18px;"
          /></router-link>
          <!--        <a href="#" class="icon_menunav_new"-->
          <!--          ><img src="../../public/img/icons/printer.svg" style="height: 18px;"-->
          <!--        /></a>-->
        </div>
        <div class="row" slot="content-header" slot-scope="{ closeMenu }">
          <div class="col-6 collapse-brand">
            <a href="#">
              <img :src="$t('app.blue_logo')"/>
            </a>
          </div>
          <div class="col-6 collapse-close">
            <close-button @click="closeMenu"></close-button>
          </div>
        </div>

        <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
          <div class="nav-item">
            <router-link to="/" class="nav-link" exact>
              <span class="nav-link-inner--text">{{ $t("menu.main") }}</span>
            </router-link>
          </div>
          <base-dropdown tag="li" class="nav-item">
            <a
                slot="title"
                href="#"
                class="nav-link_new"
                data-toggle="dropdown"
                role="button"
            >
              <i class="ni ni-collection d-lg-none"></i>
              <span class="nav-link-inner--text">{{ $t("menu.pro_about") }}</span>
            </a>
            <router-link to="/rahbariyat" class="dropdown-item">{{
                $t("submenu.leaders")
              }}
            </router-link>
            <router-link to="/tuzilma" class="dropdown-item">{{
                $t("menu.pro_structure")
              }}
            </router-link>
            <router-link to="/taskfunction" class="dropdown-item">{{
                $t("submenu.task_main")
              }}
            </router-link>
            <router-link to="/kadrlar" class="dropdown-item">{{
                $t("submenu.staff")
              }}
            </router-link>
            <router-link to="/prokuror_klubi" class="dropdown-item">{{
                $t("submenu.prokuror_klubi")
              }}
            </router-link>
            <router-link to="/gerbflag" class="dropdown-item">{{
                $t("submenu.gerbflag")
              }}
            </router-link>
          </base-dropdown>
          <!--        <div class="nav-item">-->
          <!--          <router-link to="/tuzilma" class="nav-link">-->
          <!--            <span class="nav-link-inner&#45;&#45;text">{{-->
          <!--              $t("menu.pro_structure")-->
          <!--            }}</span>-->
          <!--          </router-link>-->
          <!--        </div>-->
          <base-dropdown tag="li" class="nav-item">
            <!--                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">-->
            <a
                slot="title"
                href="#"
                class="nav-link_new"
                data-toggle="dropdown"
                role="button"
            >
              <i class="ni ni-collection d-lg-none"></i>
              <span class="nav-link-inner--text">{{
                  $t("menu.pro_active")
                }}</span>
            </a>
            <router-link to="/faoliyatochiqligi" class="dropdown-item">{{
                $t("submenu.activity")
              }}
            </router-link>
            <router-link to="/qonuniylikmustahkamlash" class="dropdown-item">{{
                $t("submenu.legitimacy")
              }}
            </router-link>
            <router-link to="/ijtimoiy" class="dropdown-item">{{
                $t("submenu.health_care")
              }}
            </router-link>
            <router-link to="/tadbirkorlik" class="dropdown-item">{{
                $t("submenu.business_law")
              }}
            </router-link>
            <!--          <router-link to="/voyagayetmaganlar" class="dropdown-item">{{-->
            <!--            $t("submenu.young_law")-->
            <!--          }}</router-link>-->
            <router-link to="/yoshlar_bizning" class="dropdown-item">{{
                $t("menu.yoshlarbizning")
              }}
            </router-link>
            <router-link to="/yoshlarsiyosati" class="dropdown-item">{{
                $t("submenu.yoshlar_siyosati")
              }}
            </router-link>
            <router-link to="/jinoyatchilikkaqarshi" class="dropdown-item">{{
                $t("submenu.crime_law")
              }}
            </router-link>
            <router-link to="/sudlarda" class="dropdown-item">{{
                $t("submenu.court")
              }}
            </router-link>
            <router-link to="/murojaatlar" class="dropdown-item">{{
                $t("submenu.reference")
              }}
            </router-link>
            <router-link to="/xalqaro_hamkorlik" class="dropdown-item">{{
                $t("menu.xalqaro")
              }}
            </router-link>
            <router-link to="/qonunchilik" class="dropdown-item">{{
                $t("submenu.law_propagan")
              }}
            </router-link>
            <router-link to="/muvofiqlashtiruvchi" class="dropdown-item">{{
                $t("submenu.jamoatchilik_kengashi")
              }}
            </router-link>
            <!--                        <router-link to="/jamoatchilikkengashi" class="dropdown-item">{{-->
            <!--                            $t("submenu.budjet_qonun")-->
            <!--                            }}</router-link>-->
            <router-link to="/mukofot" class="dropdown-item">{{
                $t("submenu.mukofot")
              }}
            </router-link>
            <router-link to="/korrupsiyagaqarshi" class="dropdown-item">{{
                $t("submenu.korrupsiyagaqarshi")
              }}
            </router-link>
            <router-link to="/xotinqizlar" class="dropdown-item">{{
                $t("submenu.xotinqizlar")
              }}
            </router-link>
            <router-link to="/ijro-intizomi" class="dropdown-item">{{
                $t("submenu.ijro-intizomi")
              }}
            </router-link>
          </base-dropdown>
          <div class="nav-item">
            <router-link to="/ochiqmalumot" class="nav-link">
              <span class="nav-link-inner--text">{{ $t("submenu.ochiq_malumot") }}</span>
            </router-link>
          </div>
<!--          <div class="nav-item">-->
<!--            <router-link to="/xalqaro_hamkorlik" class="nav-link">-->
<!--              <span class="nav-link-inner&#45;&#45;text">{{ $t("menu.xalqaro") }}</span>-->
<!--            </router-link>-->
<!--          </div>-->
          <div class="nav-item">
            <router-link to="/hujjatlar" class="nav-link">
                            <span class="nav-link-inner--text">{{
                                $t("menu.pro_normative")
                              }}</span>
            </router-link>
          </div>

          <router-link to="/pressservice" class="nav-link">
            <span class="nav-link-inner--text">{{ $t("menu.press") }}</span>
          </router-link>
          <router-link to="/davlat_dasturi" class="nav-link">
            <span class="nav-link-inner--text">{{ $t("menu.davlatdasturi") }}</span>
          </router-link>
<!--          <router-link to="/sector" class="nav-link">-->
<!--                        <span class="nav-link-inner&#45;&#45;text">{{-->
<!--                            $t("submenu.sector_news")-->
<!--                          }}</span>-->
<!--          </router-link>-->
          <div class="nav-item">
            <router-link to="/contact" class="nav-link">
                            <span class="nav-link-inner--text">{{
                                $t("submenu.contact")
                              }}</span>
            </router-link>
          </div>
          <div class="nav-item">
            <router-link to="/savol-javob" class="nav-link">
                            <span class="nav-link-inner--text">{{
                                $t("menu.savoljavob")
                              }}</span>
            </router-link>
          </div>
          <div class="nav-item">
            <router-link to="/vacancy" class="nav-link">
                            <span class="nav-link-inner--text">{{
                                $t("menu.vacancy")
                              }}</span>
            </router-link>
          </div>
        </ul>
        <div class="search_nav">
          <el-select
              style="max-width: 250px;"
              size="mini"
              clearable
              filterable
              remote
              :no-data-text="$t('app.no_data_found')"
              :no-match-text="$t('app.no_data_found')"
              v-model="searchSelect"
              :loading="loadingSuggestions"
              :remote-method="fetchSuggestions"
              :placeholder="$t('app.bosh_input')"
              @change="onSearchSelect">
            <el-option
                v-for="item in suggestions"
                :key="item.id"
                style="width: 400px"
                :label="item.titleUzLat"
                :value="item.id">
                            <span>
                                <router-link :to="`/newsview?id=${item.id}`">
                                    <span :title="item.titleUzLat" v-if="$i18n.locale === 'uz-UZ'"><span
                                        style="color: dodgerblue">{{
                                        parseDate(item.createdDate)
                                      }}</span> {{ item.titleUzLat }}</span>
                                    <span :title="item.titleUz" v-if="$i18n.locale === 'uz-CYR'"><span
                                        style="color: dodgerblue">{{
                                        parseDate(item.createdDate)
                                      }}</span> {{ item.titleUz }}</span>
                                    <span :title="item.tilteRu" v-if="$i18n.locale === 'ru-RU'"><span
                                        style="color: dodgerblue">{{
                                        parseDate(item.createdDate)
                                      }}</span> {{ item.tilteRu }}</span>
                                    <span :title="item.titleEn" v-if="$i18n.locale === 'en-US'"><span
                                        style="color: dodgerblue">{{
                                        parseDate(item.createdDate)
                                      }}</span> {{ item.titleEn }}</span>
                                    <span :title="resolveUzQrValue(item, ['titleQrq', 'titleUzQr'], 'titleUzLat')" v-if="$i18n.locale === 'uz-QR'"><span
                                        style="color: dodgerblue">{{
                                        parseDate(item.createdDate)
                                      }}</span> {{ resolveUzQrValue(item, ['titleQrq', 'titleUzQr'], 'titleUzLat') }}</span>
                                </router-link>
                            </span>
            </el-option>
          </el-select>
        </div>
      </base-nav>
    </header>
    <el-dialog
        class="poll-dialog"
        :visible="reportIssueDialogVisible"
        :show-close=false
        @close="closeReportDialog"
        width="50%">
      <el-card :body-style="{height: 'auto'}">
        <div style="width: -webkit-fill-available">
          <div>
            <p style="background-color: antiquewhite; padding: 10px; border-radius: 20px;">{{
                $t("app.what_error")
              }}</p>
          </div>
          <div>
            <h5 v-if="this.issueText !== ''">" {{ this.issueText }} "</h5>
            <br>
          </div>
          <el-row>
            <el-col :span="24">
              <textarea style="width: 100%;" rows="10" v-model="editedText"></textarea>
            </el-col>
          </el-row>
          <br>
          <div>
            <el-button type="primary" style="float:right; margin-right: 5px" size="mini" @click="sendReport" round>
              {{ $t("app.send") }}
            </el-button>
            <el-button type="warning" style="float:right; margin-right: 5px" size="mini" @click="closeReportDialog()"
                       round>
              {{ $t("app.cancel") }}
            </el-button>
          </div>
        </div>
      </el-card>
    </el-dialog>
    <el-dialog
        :title="$t('app.bosh_spes')"
        :visible.sync="speakDialogVisible"
        width="30%"
        center>
      <span style="word-break: break-word;"><i class="el-icon-headset"></i> {{ $t("app.bosh_speak") }} <span style="background: #3390ff; color: #fff; padding: 4px;">{{ $t("app.bosh_speaks") }}</span></span>
    </el-dialog>
    <div class="feedback" @click="reportIssueDialogVisible = true">
      <i class="el-icon-s-comment"></i><span>{{ $t('app.send_feedback') }}</span>
    </div>
  </div>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import SpecialFeatures from "@/components/SpecialFeatures";
import moment from "moment";
// import AccessibilityToolbar from 'vue-accessibility-toolbar';

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    SpecialFeatures
  },
  data() {
    return {
      categories: [],
      searchSelect: null,
      loadingSuggestions: false,
      speakDialogVisible: false,
      issueText: "",
      editedText: "",
      reportIssueDialogVisible: false,
      suggestions: [],
      time: "",
      date: "",
      week: ["Вс", "Пн", "Вт.", "Ср.", "Чт.", "Пт", "Сб"]
    };
  },
  methods: {
    changeLang(locale) {
      this.$store.commit("setLocale", locale);
      this.$i18n.locale = locale;
    },
    localeStyle(locale) {
      return this.$i18n.locale === locale ? "active" : "";
    },
    loadCategories() {
      this.$axios
          .get(`https://www.prokuratura.uz/api/categories/all`)
          .then(response => {
            response.data.forEach(category => {
              if (this.$i18n.locale === "en-US") {
                category.nameUz = category.nameEn;
              } else if (this.$i18n.locale === "ru-RU") {
                category.nameUz = category.nameRu;
              } else if (this.$i18n.locale === "uz-UZ") {
                category.nameUz = category.nameUzLat;
              } else if (this.$i18n.locale === "uz-QR") {
                category.nameUz = this.resolveUzQrValue(category, ["nameQrq", "nameUzQr"], "nameUzLat");
              }
              this.categories.push(category);
            });
          });
    },
    resolveUzQrValue(item, qrKeys, fallbackKey) {
      const value = qrKeys.map(key => item && item[key]).find(Boolean);
      return value || (item && item[fallbackKey]) || "";
    },
    updateTime() {
      let cd = new Date();
      this.time =
          this.zeroPadding(cd.getHours(), 2) +
          ":" +
          this.zeroPadding(cd.getMinutes(), 2) +
          ":" +
          this.zeroPadding(cd.getSeconds(), 2);
      this.date =
          this.zeroPadding(cd.getDate(), 2) +
          "." +
          this.zeroPadding(cd.getMonth() + 1, 2) +
          "." +
          this.zeroPadding(cd.getFullYear(), 4) +
          " " +
          this.week[cd.getDay()];
    },
    zeroPadding(num, digit) {
      let zero = "";
      for (let i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },

    fetchSuggestions(query) {
      this.loadingSuggestions = true;
      this.suggestions = [];
      this.$axios
          // .get(`http://172.18.45.189:8080/api/news/by-search?searchKey=${query}`)
          .get(`https://www.prokuratura.uz/api/news/by-search?searchKey=${query}`)
        .then(response => {
          this.loadingSuggestions = false;
          this.suggestions = response.data;
        });
    },

    onSearchSelect() {
      if (this.searchSelect !== null && this.searchSelect !== "") {
        console.log("");
      }
    },
    parseDate(dateTime) {
      return moment(dateTime).format("DD.MM.YYYY");
    },
    reportIssue() {
      this.reportIssueDialogVisible = true;
    },
    closeReportDialog() {
      this.reportIssueDialogVisible = false;
      this.editedText = "";
    },
    sendReport() {
      let errorNotes = {
        errorText: this.editedText.replaceAll("%", ""),
        selectedText: this.issueText.replaceAll("%", ""),
        errorPage: this.$route.fullPath
      };
      this.$axios
          // .get(`http://172.18.45.189:8080/api/error-notes/create?error=${errorNotes.errorText}&selected=${errorNotes.selectedText}&route=${errorNotes.errorPage}`)
          .get(`https://www.prokuratura.uz/api/error-notes/create?error=${errorNotes.errorText}&selected=${errorNotes.selectedText}&route=${errorNotes.errorPage}`)
          .then(response => {
              if (response.data === "") {
                  this.$message({
                      type: "warning",
                      message: this.$t("general.tryLater")
                  });
              } else {
                  this.$message({
                      type: "success",
                      message: this.$t("app.feedback_sent")
                  });
              }
            this.reportIssueDialogVisible = false;
          });

    }
  },
  mounted() {
    window.addEventListener("keypress", function (e) {
      if (e.ctrlKey && e.keyCode == 10) {
        let str = '';
        str += window.getSelection();
        this.issueText = str;
        this.editedText = str;
        this.reportIssue();
      }
    }.bind(this));
  },
  created() {
    setInterval(this.updateTime, 1000);
    this.updateTime();
    this.loadCategories();
  }
};
</script>
<style lang="scss" scoped>
@import url(../assets/css/custom.scss);

.feedback {
  position: fixed;
  top: 50%;
  right: -135px;
  transform: translateY(-50%) rotate(-90deg);
  width: 300px;
  height: 40px;
  background: #96b4d3;
  z-index: 100;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 35px 35px 0 0;
  transition: .4s;
  padding: 0 20px;
  font-size: 16px;
  font-weight: normal;
  line-height: 0;
}

.feedback:hover {
  background: #394869;
}

h5 {
  color: white;
}

.feedback i {
  color: white;
  font-size: 22px;
}


.demo_test {
  position: absolute;
  color: #7867f2;
  font-size: 12px;
  top: 5px;
  background: #ffffffb5;
  border: 1px solid;
  border-radius: 4px;
  padding: 3px 6px;
  text-transform: uppercase;
  left: 58px;
  display: -webkit-box;
}

.new_time {
  font-size: 14px;
  margin-right: 5px;
  color: #7f7f7f;
}

.new_date {
  font-size: 14px;
  margin-right: 5px;
  color: #7f7f7f;
}

.vacancy-link {
    float: right;
    margin-top: 4.5%;
    margin-right: 20px;
}
</style>
